import React from "react";
import Flag from "react-world-flags";
import './StudentFlag.scss'
import { codeFlagFinder } from "../../helper/codeFlagFinder";
import { countryCodes } from "../../helper/countryCodes";

const StudentFlag = ({ nationality }) => {
  const code = codeFlagFinder(countryCodes, nationality);
  return (
    <div className="flag-container">
      <Flag code={code} height="16" />
    </div>
  );
};

export default StudentFlag;
